import styled from "styled-components";

export const QuizContainer = styled.section`
  &.active {
    opacity: 1;
    pointer-events: all;
  }
  &.inactive {
    opacity: 0.5;
    pointer-events: none;
  }
`;

